import React, { useEffect, useState } from 'react';

import { GoogleMap, useLoadScript } from '@react-google-maps/api';

import config from "../../../../../../../../application/config/config";

import MapDirectionsRenderer from './MapDirectionsRendered';
import sleep from 'sleep-promise';

const libraries = ['places'];

const containerStyle = {
  width: '100%',
  height: '100%'
};

const Map = ({
  points,
  travelType,
  onChange
}) => {

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: config.gmaps_key,
    libraries,
  });

  const [routeContent, setRouteContent] = useState(null)

  const loadRoute = async () => {
    setRouteContent(null)

    await sleep(50)

    setRouteContent(
      <MapDirectionsRenderer
        places={points}
        travelMode={travelType}
        onChange={onChange}
      />
    )
  }

  useEffect(() => {
    loadRoute()
  }, [travelType])

  if (isLoaded) {
    return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        zoom={9}
      >
        {routeContent}
      </GoogleMap>
    )
  } else {
    return null
  }

};

export default Map;